﻿/**
 * authentication Module
 * @module authenticationModule
 * @namespace components.authenticationModule
 */
'use strict';

angular.module('components.authenticationModule', [
    'components.connectionsModule',
    'ngCookies',
    'restangular',
    'ui.router'
])
.factory('authenticationFactory', require('./authenticationFactory.js'))
.factory('authenticationUIFactory', require('./authenticationUIFactory.js'))
.controller('logInController', require('./logInController.js'))
.config(['$stateProvider', function ($stateProvider) {

    $stateProvider.state('authentication', {
        url: '/authentication',
        abstract: true,
        templateUrl: require('./login.html'),
        data: {
            bodyCSS: 'login-body'
        }
    });

    $stateProvider.state('authentication.login', {
        url: '/login'
    });

    $stateProvider.state('authentication.logout', {
        url: '/logout'
    });
}]);



//////////////////
// WEBPACK FOOTER
// ./source/angular/components/authentication/index.js
// module id = 7
// module chunks = 0